<template>
    <nav class="decade-nav">
      <ul>
        <li v-for="decade in decades" :key="decade" :class="{ 'selected': selectedDecade === decade, 'hovered': !timelineTransitioning && hoveredDecade === decade }" @mouseenter="hoverDecade(decade)" @mouseleave="unhoverDecade">
          <a :href="'#' + decade + 's'" @click.prevent="handleNavClick(decade)"><span>{{ decade + 's' }}</span></a>
        </li>
      </ul>
    </nav>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  
  export default {
    computed: {
      ...mapGetters([
        'decades',
        'selectedDecade',
        'timelineTransitioning',
      ])
    },
    methods: {
      ...mapActions(['selectDecade']),
      handleNavClick(decade) {
        this.hoveredDecade = 0;
        this.selectDecade(decade);
      },
      hoverDecade(decade) {
        this.hoveredDecade = decade;
      },
      unhoverDecade() {
        this.hoveredDecade = 0;
      },
    },
    data() {
      return {
        hoveredDecade: 0,
      };
    },
    mounted() {
      this.$store.dispatch('fetchDecades');
    }
  }
</script>  


// WEBPACK FOOTER //
// DecadeNav.vue?2d2f6430